var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DealerPrice',{attrs:{"disable":_vm.isQuoteAccepted,"has-pricing":_vm.hasPricing,"dealers-price":_vm.dealersPrice},on:{"select:price":_vm.priceSelected,"close":_vm.close}})
}
var staticRenderFns = []

export { render, staticRenderFns }